import { createAction } from 'redux-actions'

export const fetchNextModalStart = createAction('FETCH_NEXT_MODAL_START')
export const fetchNextModalSuccess = createAction('FETCH_NEXT_MODAL_SUCCESS')
export const fetchNextModalError = createAction('FETCH_NEXT_MODAL_ERROR')
